import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getName } from '../../../../state/components/selectors.tsx';
import type { State } from '../../../../state/reducer.tsx';
import { getIssuesUrl } from '../../../../state/selectors.tsx';
import ComponentView from './view.tsx';

type Props = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: Props) => ({
	name: getName(state, ownProps.componentId),
	issuesUrl: getIssuesUrl(state, ownProps.componentId),
});

export default connect(mapStateToProps, {})(ComponentView);
